import React from "react";

export type ProjectContentContextValue = Record<string, never>;

const defaultValue: ProjectContentContextValue = {};

export const ProjectContentDataContext = React.createContext<ProjectContentContextValue>(defaultValue);

export const useProjectContentData = () => React.useContext(ProjectContentDataContext);
